// import { addFilter, filterItems } from "@/redux/features/filterSlice";
import axiosInstance from "@/service/axiosInstance";
import {
  APP_NAME,
  ClassificationTypes,
  PRIVATE_PRODUCTS_ACCESS_ROLES,
  ToastOptions,
} from "@/utils/enum";

import axios from "axios";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import { commonSelectStyles } from "@/utils/utils";
import { FaInfoCircle } from "react-icons/fa";

export interface filter {
  eventsType: any;
  eventsMode: any;
  location: any;
  currentPage: any;
  school: any;
  age: any;
  category: any;
  gender: any;
  registrationStatus: any;
  privateEvents?: boolean;
}
interface filterProps {
  handleResetFilter: any;
  getData: (currentPage: any, filter: any) => Promise<void>;
  currentPage: any;
  setcurrentPage: any;
  isMobile?: boolean;
  closeMobileModal?: any;
  filter: any;
  addFilter: any;
  search: any;
  setSearch: any;
  paginatedEvents: any;
  schools: any;
  setSchools: any;
}
const eventOptions = [
  "Competition",
  "Workshop",
  "Sports",
  "The Stars Ensemble",
  "The Junior Stars Ensemble",
  "Sponsorship",
  "Family Fiesta",
];

const eventTypeOptions = ["Online", "Offline"];

const categories = [ClassificationTypes.Individual, ClassificationTypes.Group];

const gender = [ClassificationTypes.Male, ClassificationTypes.Female];

const ageOptions = [
  { value: null, label: "NA" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
];

const FilterForm = ({
  handleResetFilter,
  setcurrentPage,
  getData,
  currentPage,
  isMobile,
  closeMobileModal,
  filter,
  addFilter,
  search,
  setSearch,
  paginatedEvents,
  schools,
  setSchools,
}: filterProps) => {
  // const filter = useSelector(filterItems);

  const dispatch = useDispatch();

  const [zones, setZones] = useState([]);
  const [gradeOptions, setGradeOptions] = useState<any>([]);

  const [locations, setLocations] = useState<any>([]);

  const [locationLoading, setLocationLoading] = useState(false);
  const [schoolLoading, setShoolLoading] = useState(false);
  const searchTimerRef = useRef<NodeJS.Timeout | null>(null);

  const userRole = useSelector((state: any) => state.auth.userRole);
  const filterRef = useRef(filter);

  useEffect(() => {
    filterRef.current = filter;
  }, [filter]);

  const handleEventChange = (e: ChangeEvent<HTMLInputElement>) => {
    const event = e.target.value;
    const isChecked = e.target.checked;

    const updatedEventsType = isChecked
      ? [...filter?.eventsType, event]
      : filter?.eventsType.filter((item: any) => item !== event);

    const updatedFilter = {
      ...filter,
      eventsType: updatedEventsType,
      currentPage: 1,
    };

    dispatch(addFilter(updatedFilter));
    // getData(0, updatedFilter);
  };

  const getGrades = async () => {
    try {
      const { data } = await axiosInstance.get("/grade");

      let structuredGradeData: any = [];

      for (let i = 0; i < data.length; i++) {
        structuredGradeData.push({
          label: data[i]?.attributes?.name,
          value: data[i]?.attributes?.Calculation_Value,
          order: data[i]?.attributes?.order,
        });
      }

      const newGradesMapping = structuredGradeData.reduce(
        (acc: any, obj: any) => {
          acc[obj.label] = obj;
          return acc;
        },
        {},
      );

      newGradesMapping["Sr. K.G."] = newGradesMapping["Sr.KG"];
      newGradesMapping["Jr. K.G."] = newGradesMapping["Jr.KG"];
      structuredGradeData.sort((a: any, b: any) => a.order - b.order);

      setGradeOptions(structuredGradeData);
    } catch (error: any) {
      console.log("Error in loading grades :>> ", error.data || error);
      return [];
    }
  };

  const handleRegistrationsOpenChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    dispatch(
      addFilter({
        ...filter,
        registrationsOpen: isChecked,
      }),
    );
  };

  const handleEventTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const event = e.target.value;
    const isChecked = e.target.checked;

    const updatedEventsMode = isChecked
      ? [...filter?.eventsMode, event]
      : filter?.eventsMode.filter((item: any) => item !== event);

    const updatedFilter = {
      ...filter,
      eventsMode: updatedEventsMode,
      currentPage: 1,
    };

    dispatch(addFilter(updatedFilter));
    // getData(0, updatedFilter);
  };

  const handleLocationChange = (e: any) => {
    setShoolLoading(true);
    let updatedFilter;

    if (e) {
      updatedFilter = {
        ...filter,
        location: e,
        school: null,
        school_id: [],
        currentPage: 1,
      };
      const schoolsWithLocation = zones
        .filter((doc: any) => doc.attributes.Zone === e.value)
        .sort((a: any, b: any) => {
          const schoolA =
            a.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";
          const schoolB =
            b.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";

          return schoolA.localeCompare(schoolB);
        })
        .map((school: any) => {
          const name = school.attributes.School_Name.data?.attributes.name;

          return {
            value: name,
            label: name,
          };
        });

      const uniqueSchools = Array.from(
        new Map(schoolsWithLocation.map((s) => [s.value, s])).values(),
      );

      setSchools(uniqueSchools);
    } else {
      getAndSetSchools(zones);
      updatedFilter = {
        ...filter,
        school: null,
        location: null,
        school_id: [],
        currentPage: 1,
      };
    }
    dispatch(addFilter(updatedFilter));
    // getData(0, updatedFilter);
    setShoolLoading(false);
  };

  const handleSchoolChange = (e: any) => {
    let updatedFilter;

    if (e) {
      const selectedSchoolName = e.value;
      const selectedSchool: any = zones.find(
        (zone: any) =>
          zone.attributes.School_Name.data?.attributes.name ===
          selectedSchoolName,
      );

      const schoolId =
        selectedSchool?.attributes?.School_Name?.data?.attributes
          ?.school_parent_id;

      if (schoolId) {
        updatedFilter = {
          ...filter,
          school: {
            label: e.label,
            value: e.value,
            school_id: String(schoolId),
          },
          school_id: [String(schoolId)],
          currentPage: 1,
        };
        dispatch(addFilter(updatedFilter));
        // getData(0, updatedFilter);
      }
    } else {
      updatedFilter = {
        ...filter,
        school: null,
        school_id: [],
        currentPage: 1,
      };
      dispatch(addFilter(updatedFilter));
      // getData(0, updatedFilter);
    }
  };

  const handleAgeChange = (e: any) => {
    const age = e?.value;

    const updatedFilter = {
      ...filter,
      age,
      grade: null,
      currentPage: 1,
    };

    dispatch(addFilter(updatedFilter));
    // getData(0, updatedFilter);
  };

  const handleGradeChange = (e: any) => {
    const grade = e?.value;

    const updatedFilter = {
      ...filter,
      grade,
      age: null,
      currentPage: 1,
    };

    dispatch(addFilter(updatedFilter));
    // getData(0, updatedFilter);
  };

  const handleGenderChange = (e: ChangeEvent<HTMLInputElement>) => {
    const gender = e.target.value;
    if (e.target.checked) {
      dispatch(addFilter({ ...filter, gender }));
    }
  };

  const handleCategoryChange = (e: ChangeEvent<HTMLInputElement>) => {
    const category = e.target.value;
    if (e.target.checked) {
      const updatedFilter = {
        ...filter,
        category: [category],
        currentPage: 1,
      };
      dispatch(addFilter(updatedFilter));
      // getData(0, updatedFilter);
    }
  };

  const getLocations = async () => {
    try {
      setLocationLoading(true);
      const data = await axiosInstance.get("/locations");
      if (!data.data) {
        toast.error("Unable to fetch schools. Please try again.", ToastOptions);
      } else {
        let locs: any[] = [];
        const zoneMap = new Map();

        data.data.forEach((doc: any) => {
          const zone = doc.attributes.Zone;
          const schoolParentId =
            doc.attributes.School_Name?.data?.attributes?.school_parent_id;

          locs.push({
            value: zone,
            label: zone,
          });

          if (!zoneMap.has(zone)) {
            zoneMap.set(zone, new Set());
          }

          if (schoolParentId) {
            zoneMap.get(zone).add(schoolParentId);
          }
        });

        const uniqueLocs = Array.from(
          new Set(locs.map((loc) => JSON.stringify(loc))),
        ).map((loc: any) => JSON.parse(loc));

        // Result: [{ value, label, school_parent_ids }]
        const zonesWithSchoolParents = uniqueLocs.map((zone: any) => ({
          ...zone,
          school_parent_ids: Array.from(zoneMap.get(zone.value) || []),
        }));

        setZones(data.data);
        setLocations(zonesWithSchoolParents);

        if (data.data) {
          getAndSetSchools(data.data);
        }

        return zonesWithSchoolParents;
      }
    } catch (error) {
      console.log("Error in getLocations", error);
    } finally {
      setLocationLoading(false);
    }
  };

  const getMetabaseSchools = async () => {
    try {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/metabase-schools`,
      );
      const data = response.data;

      if (!data || !Array.isArray(data)) {
        toast.error("Failed to fetch schools", ToastOptions);
        return null;
      }

      let schoolData = data.map((item: any) => ({
        value: item.venue_name,
        label: item.venue_name,
      }));

      const uniqueSchools = Array.from(
        new Map(schoolData.map((s) => [s.value, s])).values(),
      );

      const sortedSchoolData = uniqueSchools.sort((a, b) =>
        a.value.toUpperCase().localeCompare(b.value.toUpperCase()),
      );

      setSchools(sortedSchoolData);
    } catch (error: any) {
      console.log(
        "Error in getMetabaseSchools :>> ",
        error.response?.data || error.message,
      );
      return null;
    }
  };

  const handlePrivateProducts = async (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(addFilter({ ...filter, privateEvents: e.target.checked }));
  };

  const handleGroupNameSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }

    searchTimerRef.current = setTimeout(() => {
      const updatedFilter = {
        ...filterRef.current,
        eventSearchBox: value,
        currentPage: 1,
      };

      dispatch(addFilter(updatedFilter));
    }, 500);
  };

  const getAndSetSchools = async (citys: any) => {
    const schoolsWithLocation = citys
      .filter((zone: any) => {
        if (filter.location?.value) {
          return zone.attributes.Zone === filter.location?.value;
        }
        return true;
      })
      .sort((a: any, b: any) => {
        const schoolA =
          a.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";
        const schoolB =
          b.attributes.School_Name.data?.attributes.name?.toUpperCase() || "";

        return schoolA.localeCompare(schoolB);
      })
      .map((school: any) => {
        const name = school.attributes.School_Name.data?.attributes.name;
        return {
          value: name,
          label: name,
        };
      });

    const uniqueSchools = Array.from(
      new Map(schoolsWithLocation.map((s) => [s.value, s])).values(),
    );

    setSchools(uniqueSchools);
  };

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_APP_NAME == APP_NAME.SUMMER_CAMP_PRIVATE) {
      getMetabaseSchools();
    } else {
      getLocations();
    }
  }, [paginatedEvents]);

  useEffect(() => {
    getGrades();
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setcurrentPage(1);
        await new Promise((resolve) => {
          const prevFilter = { ...filter };
          const newFilter = {
            ...prevFilter,
            currentPage: 1,
          };
          dispatch(addFilter(newFilter));
          resolve(newFilter);
          return newFilter;
        });
        const updatedFilter = { ...filter, currentPage: 1 };
        // console.log("Updated filter:", updatedFilter);
        getData(0, updatedFilter);
      }}
    >
      <div className="row gx-lg-5">
        <div className="col-12">
          <div
            className="col-12"
            style={{
              marginBottom: "0.938rem",
            }}
          >
            <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "2rem",
                marginBottom: "1.25rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              Filter{" "}
            </div>
            {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Event
              </div>
            )}

            {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
              <ul
                className="style-none d-flex flex-wrap"
                style={{
                  gap: "13px",
                }}
              >
                {eventOptions.map((event) => (
                  <li key={event} className="d-flex align-items-center">
                    <input
                      className="form-check-input me-2 cursor-pointer"
                      type="checkbox"
                      name="Events"
                      value={event}
                      checked={filter?.eventsType?.includes(event)}
                      onChange={handleEventChange}
                      id={event}
                    />
                    <label className="cursor-pointer" htmlFor={event}>
                      {event}
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
            <div
              className="col-12"
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                }}
              >
                Event Type
              </div>
              <ul
                className="style-none d-flex flex-wrap "
                style={{
                  gap: "50px",
                }}
              >
                {eventTypeOptions.map((event) => (
                  <li key={event}>
                    <input
                      
                      className="form-check-input ms-2"
                      type="checkbox"
                      name="Events"
                      value={event}
                      checked={filter?.eventsMode?.includes(event)}
                      onChange={handleEventTypeChange}
                      id={event}
                    />
                    <label className="ps-2 cursor-pointer" htmlFor={event}>
                      {event}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          )} */}

          {/* <div className="col-12" style={{ marginBottom: "0.938rem" }}>
            <ul className="style-none d-flex flex-wrap">
              <li className="d-flex gap-2">
                <input
                  // style={{
                  //   cursor: "pointer",
                  //   width: "1.2rem",
                  //   accentColor: "#3F41D1",
                  // }}
                  className="form-check-input ms-2"
                  type="checkbox"
                  name="RegistrationsOpen"
                  checked={filter?.registrationsOpen ?? true}
                  onChange={handleRegistrationsOpenChange}
                  id="registrationsOpen"
                />
                <label htmlFor="registrationsOpen" className="cursor-pointer">
                  Registrations Open
                </label>
              </li>
            </ul>
          </div> */}
          <div
            className="col-12"
            style={{
              marginBottom: "0.938rem",
            }}
          >
            <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "1.25rem",
                display: "flex",
                justifyContent: "start",
              }}
            >
              Event Type
            </div>
            <ul
              className="style-none d-flex flex-wrap "
              style={{
                gap: "50px",
              }}
            >
              {eventTypeOptions.map((event) => (
                <li key={event} className="d-flex align-items-center">
                  <input
                    className="form-check-input me-2 cursor-pointer"
                    type="checkbox"
                    name="Events"
                    value={event}
                    checked={filter?.eventsMode?.includes(event)}
                    onChange={handleEventTypeChange}
                    id={event}
                  />
                  <label className="cursor-pointer" htmlFor={event}>
                    {event}
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12" style={{ marginBottom: "0.938rem" }}>
            <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "1.25rem",
                marginBottom: "0.5rem",
                display: "flex",
                justifyContent: "start",
              }}
            >
              Search by Event Name
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. Swimming, Dancing..."
              value={search}
              onChange={handleGroupNameSearchChange}
              style={{
                borderRadius: "0.5rem",
                fontSize: "1rem",
                padding: "0.5rem 0.75rem",
              }}
            />
          </div>
          {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.SUMMER_CAMP_PRIVATE && (
            <div className="col-12">
              <div
                style={{
                  marginBottom: "0.938rem",
                }}
              >
                <div
                  className="label mb-1"
                  style={{
                    color: "#212121",
                    fontWeight: "500",
                    fontSize: "1.25rem",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  City
                </div>
                <Select
                  instanceId="selectbox1"
                  onChange={handleLocationChange}
                  options={locations}
                  value={filter?.location}
                  placeholder="Select City"
                  isClearable
                  styles={commonSelectStyles()}
                />
              </div>
            </div>
          )}
          <div className="col-12">
            <div style={{ marginBottom: "0.938rem" }}>
              <div className="d-flex align-items-center mb-1">
                <div
                  className="label"
                  style={{
                    color: "#212121",
                    fontWeight: "500",
                    fontSize: "1.25rem",
                    marginRight: "0.5rem", // spacing between label and icon
                  }}
                >
                  Host School
                </div>
                <div
                  style={{
                    marginTop: "-4px",
                  }}
                >
                  <FaInfoCircle
                    title={"Event Venue Locations."}
                    style={{
                      color: "#6c757d",
                      cursor: "pointer",
                      fontSize: "1rem",
                    }}
                  />
                </div>
              </div>
              <Select
                className="custom-select"
                placeholder="Select Host School"
                isClearable
                instanceId="selectbox2"
                onChange={handleSchoolChange}
                options={schools}
                value={filter?.school}
                isLoading={schoolLoading}
                styles={commonSelectStyles()}
              />
            </div>
          </div>

          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                className="label mb-1"
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Age
              </div>
              <Select
                className="custom-select"
                placeholder="Select Age"
                isClearable
                instanceId="selectbox3"
                onChange={handleAgeChange}
                options={ageOptions}
                defaultValue={null}
                value={ageOptions.find((age: any) => age.value == filter?.age)}
                isLoading={!ageOptions.length}
                styles={commonSelectStyles()}
              />
            </div>
          </div>
          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                className="label mb-1"
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Grade
              </div>
              <Select
                className="custom-select"
                placeholder="Select Grade"
                isClearable
                instanceId="selectbox4"
                onChange={handleGradeChange}
                options={gradeOptions}
                defaultValue={null}
                value={gradeOptions.find(
                  (grade: any) => grade.value == filter?.grade,
                )}
                isLoading={!gradeOptions.length}
                styles={commonSelectStyles()}
              />
            </div>
          </div>
          {/* <div
                        className="col-12"
                        style={{
                            marginBottom: "0.938rem",
                        }}
                    >
                        <div
                            className="mb-1"
                            style={{
                                color: "#666666",
                                fontWeight: "490",
                                font: "Graphik",
                                fontSize: "14px",
                            }}
                        >
                            Gender
                        </div>
                        <ul className="style-none d-flex flex-wrap justify-content-start">
                            <>
                                <div className="form-check mx-2">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="gender"
                                        id={ClassificationTypes.Male}
                                        value={ClassificationTypes.Male}
                                        onChange={handleGenderChange}
                                        checked={filter?.gender == ClassificationTypes.Male}
                                    />
                                    <label
                                        htmlFor=ClassificationTypes.Male
                                        style={{
                                            fontSize: "1rem",
                                            fontWeight: 400,
                                            cursor: "pointer",
                                        }}
                                    >
                                        {ClassificationTypes.Male}
                                    </label>
                                </div>
                                <div className="form-check mx-5">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="gender"
                                        id={ClassificationTypes.Female}
                                        value={ClassificationTypes.Female}
                                        onChange={handleGenderChange}
                                        checked={filter?.gender == ClassificationTypes.Female}
                                    />
                                    <label
                                        htmlFor=ClassificationTypes.Female
                                        style={{
                                            fontSize: "1rem",
                                            fontWeight: 400,
                                            cursor: "pointer",
                                        }}
                                    >
                                        {ClassificationTypes.Female}
                                    </label>
                                </div>
                            </>
                        </ul>
                    </div>  */}
          {process.env.NEXT_PUBLIC_APP_NAME != APP_NAME.VIBGYOR_ONE && (
            <div className="col-12">
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Category
              </div>
              <ul className="style-none d-flex flex-wrap justify-content-start align-items-center mb-10">
                <>
                  <div className="form-check mx-2 d-flex align-items-center ">
                    <input
                      className="form-check-input cursor-pointer"
                      type="radio"
                      name="category"
                      id={ClassificationTypes.Individual}
                      value={ClassificationTypes.Individual}
                      onChange={handleCategoryChange}
                      checked={
                        filter?.category == ClassificationTypes.Individual
                      }
                    />
                    <label
                      htmlFor={ClassificationTypes.Individual}
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        cursor: "pointer",
                        marginLeft: "0.5rem",
                      }}
                    >
                      {ClassificationTypes.Individual}
                    </label>
                  </div>

                  <div className="form-check mx-3 d-flex align-items-center">
                    <input
                      className="form-check-input cursor-pointer"
                      type="radio"
                      name="category"
                      id={ClassificationTypes.Group}
                      value={ClassificationTypes.Group}
                      onChange={handleCategoryChange}
                      checked={filter?.category == ClassificationTypes.Group}
                    />
                    <label
                      htmlFor={ClassificationTypes.Group}
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        cursor: "pointer",
                        marginLeft: "0.5rem",
                      }}
                    >
                      {ClassificationTypes.Group}
                    </label>
                  </div>
                </>
              </ul>
            </div>
          )}
          {PRIVATE_PRODUCTS_ACCESS_ROLES.includes(userRole) && (
            <div className="col-12">
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                }}
              >
                Private Events
              </div>
              <div className="form-check form-switch d-flex align-items-end gap-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="showPrivateEvents"
                  style={{ cursor: "pointer", height: "1.5rem", width: "3rem" }}
                  checked={filter.privateEvents}
                  onChange={handlePrivateProducts}
                />
                <label
                  className="form-check-label"
                  htmlFor="showPrivateEvents"
                  style={{ cursor: "pointer", height: "1.5rem" }}
                >
                  Show Private Products
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="col-12">
          <button
            type="submit"
            className="fw-300 apply-search w-100 mt-20 mb-25"
            style={{
              borderRadius: "2.5rem",
            }}
          >
            <i className="fa-light fa-magnifying-glass"></i>
            <span
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              Search
            </span>
          </button>
        </div>

        <div className="col-12">
          <div className="d-flex justify-content-center form-widget">
            <button
              type="reset"
              onClick={handleResetFilter}
              className="reset-btn"
              style={{ cursor: "pointer", background: "none", border: "none" }}
            >
              <i className="fa-regular fa-arrows-rotate"></i>
              <span
                style={{
                  fontWeight: 400,
                  fontSize: "1rem",
                  marginLeft: "0.5rem",
                }}
              >
                Reset Filter
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FilterForm;
